import React from 'react';
import './index.css';

type ButtonProps = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    onClick?: () => void;
    secondary?: boolean;
    type?: 'button' | 'submit' | 'reset' | undefined;
};

function Button({
    children,
    className,
    disabled,
    fullWidth,
    onClick,
    secondary,
    type
}: ButtonProps) {
    return (
        <button
            className={`
                button 
                ${fullWidth && 'button__fullWidth'} 
                ${secondary && 'button__secondary'}
                ${className} 
            `}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            <div className='button__content'>
                {children}
            </div>
        </button>
    );
}

export default Button;